import React from "react";
import { FillProps } from "../helpers/icons";

export const Eye: React.FC<FillProps> = ({ fill }: FillProps) => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C3.582 0 0 5 0 6C0 7 3.582 12 8 12C12.418 12 16 7 16 6C16 5 12.418 0 8 0ZM8 3.66667C6.71133 3.66667 5.66667 4.71133 5.66667 6C5.66667 7.28867 6.71133 8.33333 8 8.33333C9.28867 8.33333 10.3333 7.28867 10.3333 6C10.3333 4.71133 9.28867 3.66667 8 3.66667ZM4.33333 6C4.33333 8.02533 5.97467 9.66667 8 9.66667C10.0247 9.66667 11.6667 8.02533 11.6667 6C11.6667 3.97467 10.0253 2.33333 8 2.33333C5.97467 2.33333 4.33333 3.97467 4.33333 6Z"
        fill={fill}
      />
    </svg>
  );
};
